module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/liquidaciones/proveedores"
    }
  }, [_vm._v("Volver a la lista")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Monto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importe),
      expression: "importe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.importe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importe = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de pago")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Efectivo"
    }
  }, [_vm._v("Efectivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cheque"
    }
  }, [_vm._v("Cheque")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transferencia"
    }
  }, [_vm._v("Transferencia")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Comprobante")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comprobante),
      expression: "comprobante"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.comprobante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comprobante = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Movimientos")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.movimientos), function(movimiento) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(movimiento.fecha)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(movimiento.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(movimiento.comprobante))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!movimiento.esPago) ? _c('span', [_vm._v(_vm._s(_vm._f("formatMoneda")(movimiento.importe)))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(movimiento.esPago) ? _c('span', [_vm._v(_vm._s(_vm._f("formatMoneda")(movimiento.importe)))]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Saldo: " + _vm._s(_vm._f("formatMoneda")(_vm.saldo)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickPagar($event)
      }
    }
  }, [_vm._v("Guardar")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "label label-info",
    attrs: {
      "for": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Comprobante")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto a pagar")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto pagado")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-525554cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Liquidaciones/FormPago.vue
// module id = 1126
// module chunks = 5